<template>
    <div class="real-time-pie">
        <p class="pie-device-status">{{$t('she_bei_bang_dan')}} Top10</p>
        <div class="real-time-pie-chart" id="top10DevicePieChart">
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import pie from './pie'
    import {orderDeviceTop10} from '@/api/delivery/order/order'
    export default {

        data() {
            return {
                pie,
                data: {
                    normal: 1548,
                    offline: 234,
                    warning: 310,
                    fault: 335,
                },
                myChart: null,
            }
        },
        methods: {
            init(){
                this.myChart = echarts.init(document.getElementById('top10DevicePieChart'));
                orderDeviceTop10().then(res => {
                    this.pie.legend.data = []
                    this.pie.series[0].data = []
                    for (let i = 0; i < res.data.length; i++) {
                        this.pie.legend.data.push({
                            name: res.data[i].name, icon: 'roundRect',
                            textStyle: {
                                color: this.pie.color[i % this.pie.color.length],
                            }
                        })
                        this.pie.series[0].data.push({value: res.data[i].account, name: res.data[i].name})
                        this.chartSelect()
                    }
                    this.myChart.setOption(this.pie)
                    let vue= this
                    window.onresize = function () {
                        vue.myChart.resize()
                    }

                })
            },
            chartSelect () {
                let myChart = this.myChart
                myChart.dispatchAction({type: 'highlight', seriesIndex: 0, dataIndex: 0});//设置默认选中高亮部分
                let index = 0;
                let data = this.pie.series[0].data
                var fhourTime = null;
                let pie = this.pie
                fhourTime = setInterval(function () {
                    myChart.dispatchAction({
                        type: "downplay",
                        seriesIndex: 0,

                    });
                    myChart.dispatchAction({
                        type: "highlight",
                        seriesIndex: 0,
                        dataIndex: index
                    });
                    pie.legend.selected[data[index]] = true
//                    myChart
                    index++;
                    if (index > data.length) {
                        index = 0;
                    }
                }, 2000);

                myChart.on('mouseover', function (e) {
                    clearInterval(fhourTime)
                });

                myChart.on('mouseout', function (e) {

                    fhourTime = setInterval(function () {
                        myChart.dispatchAction({
                            type: "downplay",
                            seriesIndex: 0,

                        });
                        myChart.dispatchAction({
                            type: "highlight",
                            seriesIndex: 0,
                            dataIndex: index
                        });
                        myChart.dispatchAction({
                            type: "showTip",
                            seriesIndex: 0,
                            dataIndex: index
                        });
                        index++;
                        if (index > data.length) {
                            index = 0;
                        }
                    }, 2000);

                });
            }
        },

        mounted() {
            this.init()
        },
        beforeDestroy () {
            this.myChart.clear()
        },
        watch: {
            series(){

            }
        }
    }
</script>

<style lang="scss">
    .real-time-pie {
        padding: $padding;
        .pie-device-status {
            font-size: 18px;
            font-weight: $w1;
            color: $f_th_color;
        }
        .real-time-pie-chart {
            width: 100%;
            height: 100%;
        }
    }
</style>
